import React from "react";
import { classNames } from "../utils/classNames";
import { HeaderNavigation } from "./Navigation/Navigation";
import { HeaderTitle } from "./Title/Title";
const headerPrefix = "header";
export const RawHeader = (props) => {
    const { usage = "tms" } = props;
    const headerProps = { ...props, usage };
    const isCompact = !props?.title && !props?.subtitle && !props?.reference;
    return (React.createElement("div", { className: classNames(`${headerPrefix}--${usage}`, isCompact ? `${headerPrefix}--compact` : "") },
        React.createElement(HeaderTitle, { title: props?.title, subtitle: props?.subtitle, reference: props?.reference, status: props?.status, width: props?.width?.title, right: props.right }, props?.children && props?.children),
        (props?.tabs || props?.back || props?.extra || props?.navigation) && (React.createElement(HeaderNavigation, { ...headerProps })),
        props.navigationExtra));
};
